<app-header></app-header>

<router-outlet></router-outlet>

<app-map></app-map>

<app-footer></app-footer>

<app-scroll-to-top></app-scroll-to-top>

<app-toast-container></app-toast-container>
